var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 0C6.83551 0 2.98695 2.2807 0.172324 5.98684C-0.0574412 6.27193 -0.0574412 6.72807 0.172324 7.01316C2.98695 10.7193 6.77807 13 11.0287 13C15.2794 13 19.0705 10.7193 21.8851 7.01316C22.1149 6.72807 22.1149 6.27193 21.8851 5.98684C19.0131 2.2807 15.2219 0 11.0287 0ZM11.3159 11.1184C8.50131 11.2895 6.20366 9.00877 6.37598 6.21491C6.5483 3.93421 8.38642 2.05263 10.6841 1.9386C13.4987 1.76754 15.7963 4.04825 15.624 6.84211C15.5091 9.12281 13.6136 10.9474 11.3159 11.1184ZM11.1436 9.00877C9.65013 9.12281 8.38642 7.86842 8.50131 6.38597C8.61619 5.13158 9.59269 4.10526 10.8564 4.04825C12.3499 3.93421 13.6136 5.1886 13.4987 6.67105C13.4413 7.92544 12.4073 8.89474 11.1436 9.00877Z",
    fill: "#464255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d56cf9fb32b0ae91eea6a4d359058b01.svg";
export { ForwardRef as ReactComponent };